import React from 'react';
import Button from '@mui/material/Button';
import config from '../../config';

const SupportButton: React.FC = () => {
  const spaceUrl: string = config.gChatSupportSpace;
  const SendFeedbackClick = async () => {
    window.open(spaceUrl);
  };

  return (
    <Button size="small" variant="outlined" color="inherit" onClick={SendFeedbackClick}>
      #ncc-support
    </Button>
  );
};

export default SupportButton;
